import { AddViewSupport411Component } from "../../../components/SupportSystem/ViewReports/AddViewSupport411Component";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
export function AddViewSupport411Container() {
    const titleName =
        "แบบรายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน (แบบ ชอ. 4-11)"; //ใส่ชื่อtitle ตรงนี้
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <AddViewSupport411Component />
            <Footer />
        </div>
    );
}
